import React from "react"
import { EnrollmentModal } from "./EnrollmentModal"
import BenefitEnrollmentFlow from "./steps/BenefitEnrollmentFlow"

function BenefitEnrollmentFlowContainer(props): JSX.Element {
  return (
    <EnrollmentModal {...props}>
      <BenefitEnrollmentFlow />
    </EnrollmentModal>
  )
}

export { BenefitEnrollmentFlowContainer }
